import { Divider, Stack, Typography, TypographyTypeMap } from "@mui/material"
import CurrencyFormat from "../currencyFormat/CurrencyFormat";

type ExtensionProps = {
    title: string;
    label: string | undefined;
    currency?: boolean;
}

export const StackLabel: React.FC<Partial<TypographyTypeMap> & ExtensionProps> = (
    {
        title,
        label,
        currency,
        ...rest
    }

) =>
{
    return (
        <>
            <Stack 
                direction="row" 
                spacing={2} 
                justifyContent="space-between" 
                alignItems="center"
                divider={<Divider variant="middle" component="div" className='text-divider' />}
            >
                <Typography variant="subtitle2" className='bold-label'>{title}</Typography>


                {!currency && (
                    <Typography variant="subtitle2">{label}</Typography>
                )}   

                {currency && (
                    <Typography variant="subtitle2"><CurrencyFormat value={label ?? "0"} /></Typography>
                )}   
            </Stack>
        </>
    )
}